const facilities = [
  {
    name: "USPS Lakewood Ranch",
    address: "11135 State Road 70 E, Lakewood Ranch, FL 34202",
    hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
    notes: "Primary passport acceptance facility serving Lakewood Ranch residents. Located on State Road 70 near the community's commercial corridor. Passport services by appointment only. Photo services available on-site. Serves Lakewood Ranch, Bradenton East, and surrounding Manatee County communities.",
  },
  {
    name: "USPS Bradenton Main",
    address: "1114 11th St W, Bradenton, FL 34205",
    hours: "Mon–Fri: 9:00 AM – 4:00 PM",
    notes: "Full-service passport acceptance facility approximately 20–25 minutes west of Lakewood Ranch via State Road 70 or University Parkway. By appointment required. Photo services available. Serves Bradenton, Palmetto, and western Manatee County.",
  },
  {
    name: "USPS Sarasota Main",
    address: "1669 Ringling Blvd, Sarasota, FL 34236",
    hours: "Mon–Fri: 9:00 AM – 4:00 PM",
    notes: "Full-service passport acceptance facility approximately 20–25 minutes south of Lakewood Ranch via I-75 or University Parkway. By appointment required. Photo services available. Serves Sarasota, Siesta Key, and broader Sarasota County.",
  },
  {
    name: "USPS North Port",
    address: "5950 Sam Shapiro Way, North Port, FL 34287",
    hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
    notes: "Approximately 35–40 minutes south of Lakewood Ranch via I-75. Passport services by appointment. On-site photo services available. Serves North Port, Warm Mineral Springs, and southern Sarasota County communities.",
  },
  {
    name: "Manatee County Clerk — Downtown Bradenton",
    address: "1115 Manatee Ave W, Bradenton, FL 34205",
    hours: "Mon–Fri: 8:00 AM – 5:00 PM",
    notes: "County clerk facility approximately 20–25 minutes west of Lakewood Ranch via State Road 70. Offers passport application acceptance services with notarization and document verification. Appointment strongly recommended.",
  },
];

export default function LakewoodRanchAcceptanceFacilitiesSection() {
  return (
    <section className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Where to Apply
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Lakewood Ranch, FL
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            These are the government-designated locations where you can submit your passport application with proper execution. Call ahead — appointments are often required.
          </p>
        </div>

        <div className="space-y-4">
          {facilities.map((f, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 border border-gray-100 hover:border-[#F6C344]/50 transition-all"
            >
              <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6">
                <div className="shrink-0">
                  <div className="w-12 h-12 rounded-lg bg-[#1A365D] flex items-center justify-center">
                    <i className="ri-building-line text-[#F6C344] text-xl"></i>
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="font-serif text-base font-bold text-[#1A365D] mb-1">
                    {f.name}
                  </h3>
                  <p className="text-gray-600 text-sm mb-2">
                    <i className="ri-map-pin-line text-[#B22222] mr-1"></i>
                    {f.address}
                  </p>
                  <p className="text-gray-500 text-xs mb-3">
                    <i className="ri-time-line mr-1"></i>
                    {f.hours}
                  </p>
                  <p className="text-gray-600 text-sm leading-relaxed">{f.notes}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-[#FFF8E7] border-l-4 border-[#F6C344] rounded-r-lg p-6 flex items-start gap-4">
          <i className="ri-information-line text-[#F6C344] text-xl shrink-0 mt-0.5"></i>
          <div>
            <h4 className="font-semibold text-[#1A365D] mb-1">Important Reminder</h4>
            <p className="text-gray-600 text-sm leading-relaxed">
              Acceptance facilities do <strong>not</strong> expedite your passport. They only witness your signature and forward your application to the State Department. For emergency processing, you need a registered courier like Fast Passport Center to hand-carry your application through expedited channels.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}